import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { get } from 'lodash';

import 'react-table-6/react-table.css';

import ReportBuilder from './ReportBuilder';

import './styles/ReportBuilder.css';
import './styles/EmptyReport.css';
import './styles/Table.css';

import * as filtersActions from '../../actions/filters-actions';
import * as reportBuilderActions from '../../actions/report-builder-actions';
import * as reportBuilderSelectors from '../../reducers/report-builder-reducer';
import * as userSelectors from '../../reducers/user-reducer';
import * as filtersSelectors from '../../reducers/filters-reducer';

const mapStateToProps = state => ({
  data: reportBuilderSelectors.selectData(state),
  error: reportBuilderSelectors.selectError(state),
  filters: state.filters,
  filterValues: filtersSelectors.selectFilterValues(state),
  loading: reportBuilderSelectors.selectLoading(state),
  name: reportBuilderSelectors.selectName(state),
  views: reportBuilderSelectors.selectViews(state),
  userId: userSelectors.selectUserId(state),
  savedReport: get(state, ['reportBuilder', 'savedReport'], {})
});

const mapDispatchToProps = dispatch => ({
  filtersActions: bindActionCreators(filtersActions, dispatch),
  reportBuilderActions: bindActionCreators(reportBuilderActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportBuilder);
